import axios from "axios";

export async function getCourseAccuracy(moduleId) {
  return axios
    .get(`${import.meta.env.VITE_API_BASE_URL}/api/course-stat/${moduleId}/accuracy-kpi`)
    .then((response) => response.data)
    .catch((err) => console.error(err));
}

export async function getCourseTotalAttemptsKpi(moduleId) {
  return axios
    .get(`${import.meta.env.VITE_API_BASE_URL}/api/course-stat/${moduleId}/attempts-kpi`)
    .then((response) => response.data)
    .catch((err) => console.error(err));
}

export async function getCourseStreakKpi(moduleId) {
  return axios
    .get(`${import.meta.env.VITE_API_BASE_URL}/api/course-stat/${moduleId}/streak-kpi`)
    .then((response) => response.data)
    .catch((err) => console.error(err));
}

export async function getModuleEvolutionKpi(moduleId) {
  return axios
    .get(`${import.meta.env.VITE_API_BASE_URL}/api/course-stat/${moduleId}/evolution-chart`)
    .then((response) => response.data)
    .catch((err) => console.error(err));
}

export async function getWorstAndBest(moduleId) {
  return axios
    .get(`${import.meta.env.VITE_API_BASE_URL}/api/course-stat/${moduleId}/worst-and-best`)
    .then((response) => response.data)
    .catch((err) => console.error(err));
}
